// HOOKS
import useRequiredFields from "../../../hooks/other/useRequiredFields.other.hook";
import { useState } from "react";
import useCreateProduct from "../../../hooks/products/useCreate.product";
import useReturnFormComponents from "../../../hooks/other/useReturnFormComponents";
// COMPONENTS
import DefaultModalForm from "../defaultModal.form";
import { CATEGORIES } from "../../../constants/forms/product/categories.product.form.constant";
const FORM_FIELDS = {
  name: "",
  make: "",
  model: "",
  category: "",
  external_description: "",
  repairShopr_id: "",
  retail_price: "0.00",
  tags: "",
};

const REQUIRED_FIELDS = ["make", "model", "category", "external_description"];

const ProductForm = ({ products }) => {
  const { alertMissingFields } = useRequiredFields();
  const { createProduct } = useCreateProduct();
  const { getFormComponents } = useReturnFormComponents();
  const [isLoading, setIsLoading] = useState(false);
  const [formFields, setFormFields] = useState(FORM_FIELDS);
  const {
    name,
    make,
    model,
    category,
    external_description,
    repairShopr_id,
    retail_price,
    tags,
  } = formFields;
  const handleSave = async (event) => {
    event.preventDefault();
    try {
      if (isLoading) return;
      // Check for required fields, alerts user of missing fields and
      // return if missing fields are found
      const missingFields = alertMissingFields(formFields, REQUIRED_FIELDS);
      if (missingFields.length) return;
      setIsLoading(true);
      const product = await createProduct(formFields);
      if (!product?._id) throw new Error("Failed to create product");
      setFormFields(FORM_FIELDS);
      alert(
        `Created Product: ${
          product?.name ||
          `${product?.category} ${product?.make} ${product?.model} ${product?.external_description}`
        }`
      );
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    setFormFields({ ...formFields, [event.target.name]: event.target.value });
  };
  const form = [
    {
      type: "text",
      props: {
        label: "Name",
        value: name,
        name: "name",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        required: true,
        label: "Make",
        value: make,
        name: "make",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        required: true,
        label: "Model",
        value: model,
        name: "model",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "selection",
      props: {
        options: CATEGORIES,
        required: true,
        label: "Category",
        value: category,
        name: "category",
        onChange: handleChange,
        classNames: { container: "w-96" },
      },
    },
    {
      type: "text",
      props: {
        required: true,
        label: "External Description",
        value: external_description,
        name: "external_description",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        label: "RepairShopr Id",
        value: repairShopr_id,
        name: "repairShopr_id",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "number",
      props: {
        step: "0.01",
        min: "0",
        label: "Retail Price",
        value: retail_price,
        name: "retail_price",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        label: "Tags",
        value: tags,
        name: "tags",
        onChange: handleChange,
        className: "w-96",
      },
    },
  ];
  return (
    <DefaultModalForm
      header="Create Product"
      handleClick={handleSave}
      loading={isLoading}
      saveButton={{ handleClick: handleSave, loading: isLoading }}
    >
      {getFormComponents({ fields: form })}
    </DefaultModalForm>
  );
};

export default ProductForm;
